export function esIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

export function esPWA() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}
